import {
  leadFlowEvents,
  type LeadFlowEvent,
  type LinkFailureKind,
} from "pages/StartLead/events";

import {
  deadLinkRecoveryPath,
  deadLinkShownFor,
  eventPurposeOf,
  linkSurfaceOf,
  type DeadLinkKind,
} from "./login-grant-flow";

/** What a link that failed to open reports, and the dead-link screen it shows
 * when it is one that cannot be used again. `redirect` is the path the
 * server's answer names, else the one the link carries. */
export type LinkFailurePlan = {
  events: LeadFlowEvent[];
  screen: { kind: DeadLinkKind; recoveryPath: string } | null;
};

export function linkFailurePlan(
  kind: LinkFailureKind,
  redirect: string | null,
): LinkFailurePlan {
  const purpose = eventPurposeOf(redirect);
  const failed = leadFlowEvents.linkFailed({ purpose, kind });
  const shown = deadLinkShownFor(kind);
  if (shown === null) return { events: [failed], screen: null };
  const recoveryPath = deadLinkRecoveryPath(redirect);
  return {
    events: [
      failed,
      leadFlowEvents.sessionEndedViewed({
        purpose,
        surface: linkSurfaceOf(redirect),
        stage: "link",
        resolution: recoveryPath.startsWith("/start/verify")
          ? "renew"
          : "look_up",
      }),
    ],
    screen: { kind: shown, recoveryPath },
  };
}
